import { Store } from 'pullstate'

const BatchPaymentCheckStore = new Store({ });

export default BatchPaymentCheckStore;